import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

interface IInfoCard {
  title: string;
  value: number;
  deltaValue: number;
  deltaUnit?: string;
  deltaPrecision?: number;
  precision?: number;
  chartData: number[];
  titleSize?: number;
  numberOfDays?: number;
}

const InfoCardWithChart: React.FC<IInfoCard> = ({
  title,
  value,
  deltaValue,
  deltaUnit,
  deltaPrecision,
  precision,
  chartData,
  titleSize,
  numberOfDays,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [deltaColor, setDeltaColor] = useState('#000000');

  const input = [
    {
      label: 'Data',
      data: chartData,
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: 'line',
      fontFamily: 'Poppins',
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: true,
      },
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
      width: '100%',
    },
    grid: {
      show: false,
    },
    stroke: {
      width: [4],
      curve: 'smooth',
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      type: 'category',
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      labels: {
        show: false,
      },
    },
    legend: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
    colors: ['#7030A0'],
  };

  useEffect(() => {
    if (deltaValue < 0) {
      setDeltaColor('#E55353');
    } else if (deltaValue > 0) {
      setDeltaColor('#2EB85C');
    } else {
      setDeltaColor('#000000');
    }
  }, [deltaValue]);

  return (
    <div className={classes.container}>
      <Typography
        className={classes.title}
        variant="h3"
        // gutterBottom
        style={{ fontSize: titleSize }}
      >
        {title}
      </Typography>
      <main className={classes.main}>
        <div className={classes.content}>
          <Typography
            className={classes.value}
            color="textPrimary"
            variant="body1"
          >
            {value === -1 ? '-' : value.toFixed(precision || 0)}
          </Typography>
        </div>

        <Chart
          options={options}
          series={input}
          type="line"
          height="50%"
          width="50%"
        />
      </main>
      <Typography className={classes.description} variant="h3" gutterBottom>
        <strong style={{ color: deltaColor }}>
          {deltaValue > 0 && `+`}
          {deltaValue.toFixed(deltaPrecision || 0)}
          {deltaUnit}
        </strong>{' '}
        {`${t('components:cards.inTheLast')} ${
          numberOfDays || chartData.length
        } ${t('components:cards.days')}`}
      </Typography>
    </div>
  );
};

export default InfoCardWithChart;
